import { Component, inject, Input, OnInit } from '@angular/core';
import { RapidReviewDiagnosisComponent } from '@shared/component/rapid-review-modal/rapid-review-diagnosis/rapid-review-diagnosis.component';
import { RapidReviewAssessmentAndPlanFormattedResponse, RapidReviewModalService } from '@shared/component/rapid-review-modal/rapid-review-modal.service';

@Component({
	selector: 'pms-rapid-review-assessment-and-plan',
	imports: [RapidReviewDiagnosisComponent],
	templateUrl: './rapid-review-assessment-and-plan.component.html',
})
export class RapidReviewAssessmentAndPlanComponent implements OnInit {
	private rapidReviewModalService = inject(RapidReviewModalService);

	@Input({required: true})
	encounterId: number;
	assessmentAndPlan: RapidReviewAssessmentAndPlanFormattedResponse;

	ngOnInit(): void {
		this.rapidReviewModalService.getRapidReviewAssessmentAndPlan(this.encounterId).subscribe(response => this.assessmentAndPlan = response);
	}
}
